var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightningFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 14.6663C11.6821 14.6663 14.6668 11.6816 14.6668 7.99967C14.6668 4.31778 11.6821 1.33301 8.00016 1.33301C4.31826 1.33301 1.3335 4.31778 1.3335 7.99967C1.3335 11.6816 4.31826 14.6663 8.00016 14.6663ZM8.0002 9.65915V11.7299C8.0002 12.6205 8.0002 13.0659 8.19643 13.1091C8.39265 13.1523 8.57975 12.7482 8.95394 11.9399L10.126 9.40822C10.6175 8.34655 10.8633 7.81572 10.6878 7.4061C10.6447 7.30554 10.5854 7.21274 10.5122 7.13138C10.2142 6.8 9.62928 6.8 8.45936 6.8C8.26311 6.8 8.16498 6.8 8.0975 6.74795C8.08054 6.73486 8.06534 6.71966 8.05226 6.7027C8.0002 6.63522 8.0002 6.5371 8.0002 6.34085V4.27012C8.0002 3.37946 8.0002 2.93413 7.80398 2.89091C7.60775 2.8477 7.42066 3.25182 7.04647 4.06006L5.87438 6.59178C5.38287 7.65345 5.13711 8.18428 5.31265 8.5939C5.35574 8.69446 5.41504 8.78726 5.48819 8.86862C5.78616 9.2 6.37112 9.2 7.54105 9.2C7.7373 9.2 7.83543 9.2 7.9029 9.25205C7.91986 9.26514 7.93507 9.28034 7.94815 9.2973C8.0002 9.36478 8.0002 9.4629 8.0002 9.65915Z",
    fill: "#FFBE9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningFill);
export default __webpack_public_path__ + "static/media/lightning_fill.88871442c71fa4b88742478c5d4fca55.svg";
export { ForwardRef as ReactComponent };